export default function useSuggestedActions() {
  const actionTypeDefinitions = {
    create_card: {
      headerTitleKey: 'createCard',
      acceptButtonKey: 'finaliseCard',
      acceptButtonIcon: 'card-icon',
      prefixIcon: 'user-plus',
    },
    update_card: {
      headerTitleKey: 'updateCard',
      acceptButtonKey: 'accept',
    },
    create_comment: {
      headerTitleKey: 'commentOn',
      acceptButtonKey: 'draftComment',
      acceptButtonIcon: 'message-square',
    },
    move_card: {
      headerTitleKey: 'moveCard',
      acceptButtonKey: 'moveCard',
    },
    assign_members: {
      headerTitleKey: 'addAssignees',
      acceptButtonKey: 'changeAssignees',
      prefixTitle: 'assign',
    },
    remove_members: {
      headerTitleKey: 'removeAssignees',
      acceptButtonKey: 'changeAssignees',
      prefixTitle: 'unassign',
    },
  };

  const actionTypes = {
    create_card: 'create_card',
    update_card: 'update_card',
    create_comment: 'create_comment',
    move_card: 'move_card',
    assign_members: 'assign_members',
    remove_members: 'remove_members',
  };

  const actionDetailsKeys = {
    title: 'title',
    content: 'content',
    assignees: 'assignees',
    due_date: 'due_date',
    status: 'status',
    user_ids: 'user_ids',
  };

  const getActionDetailsItemTitle = (actionType: string, key: string) => {
    switch (key) {
      case actionDetailsKeys.title:
        return 'title';
      case actionDetailsKeys.content:
        return 'description';
      case actionDetailsKeys.assignees:
        return 'assignees';
      case actionDetailsKeys.due_date:
        return 'dueDate';
      case actionDetailsKeys.status:
        return 'status';
      case actionDetailsKeys.user_ids:
        return actionType === actionTypes.assign_members ? 'assign' : 'unassign';
      default:
        return '';
    }
  };

  const shouldShowTitle = (actionType: string) => {
    return actionTypes.create_card === actionType || actionTypes.update_card === actionType;
  };

  return {
    actionTypeDefinitions,
    actionTypes,
    actionDetailsKeys,
    getActionDetailsItemTitle,
    shouldShowTitle,
  };
}
